var map = {
	"./apple.svg": "./src/assets/icons/svg/apple.svg",
	"./arrow_right.svg": "./src/assets/icons/svg/arrow_right.svg",
	"./arrow_right_hover.svg": "./src/assets/icons/svg/arrow_right_hover.svg",
	"./bodyInfo1.svg": "./src/assets/icons/svg/bodyInfo1.svg",
	"./bodyInfo2.svg": "./src/assets/icons/svg/bodyInfo2.svg",
	"./bodyInfo3.svg": "./src/assets/icons/svg/bodyInfo3.svg",
	"./calendar.svg": "./src/assets/icons/svg/calendar.svg",
	"./close.svg": "./src/assets/icons/svg/close.svg",
	"./fire.svg": "./src/assets/icons/svg/fire.svg",
	"./icon_left.svg": "./src/assets/icons/svg/icon_left.svg",
	"./icon_right.svg": "./src/assets/icons/svg/icon_right.svg",
	"./menu_home.svg": "./src/assets/icons/svg/menu_home.svg",
	"./menu_other.svg": "./src/assets/icons/svg/menu_other.svg",
	"./paypal.svg": "./src/assets/icons/svg/paypal.svg",
	"./paypal_active.svg": "./src/assets/icons/svg/paypal_active.svg",
	"./safe.svg": "./src/assets/icons/svg/safe.svg",
	"./successIcon.svg": "./src/assets/icons/svg/successIcon.svg",
	"./tagIcon.svg": "./src/assets/icons/svg/tagIcon.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons/svg sync \\.svg$";